<template lang="pug">
  section
    el-drawer(
        :title="UserTitleQR"
        :visible.sync="showdrawer"
        :with-header="true"
        :wrapperClosable="true"
        :before-close="handleClose"
        :append-to-body="false"
         size="40%")
        ods-form.vendor-form(
          label-position='top'
          :model='QRUsersFormData'
          ref="QRUsers"
          :rules="rulesQR"
          )
          h2.form-section.tp-r-deci {{ this.$t('commerceInfo.ContactInformation') }}
          .form-grid
            ods-form-item(label="Usuario" prop="usuario")
              ods-input(v-model="QRUsersFormData.usuario" :maxlength="22" :disabled="editQR")
            ods-form-item(label="Comercio" prop="codcom")
              ods-input(
                v-model="sesionCodcom.codcom"
                :disabled="editQR || createQR")
            ods-form-item(label="Nombre" prop="nombre")
              ods-input(v-model="QRUsersFormData.nombre" :maxlength="100" required)
            ods-form-item(label="Primer apellido" prop="apelli1")
              ods-input(v-model="QRUsersFormData.apelli1" :maxlength="30")
            ods-form-item(label="Segundo apellido" prop="apelli2")
              ods-input(v-model="QRUsersFormData.apelli2" :maxlength="30")
            ods-form-item(label="Email" prop="email")
              ods-input(v-model="QRUsersFormData.email" :maxlength="50")
            ods-form-item(label="Telefono móvil" prop="tel_movil"
              oninput="if(this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
              onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57")
              ods-input(maxlength="20" v-model="QRUsersFormData.tel_movil")
            ods-form-item(label="Telefono fijo" prop="tel_fijo"
              oninput="if(this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
              onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57")
              ods-input(maxlength="20" v-model="QRUsersFormData.tel_fijo")

          ods-button(@click="addUserQr(QRUsersFormData, 'QRUsers')" v-if="editQR") {{ this.$t('login.submitButton') }}
          ods-button(@click="addUserQr(QRUsersFormData, 'QRUsers')" v-if="createQR") {{ this.$t('login.submitButton') }} Nuevo
    div.btnQr
      ods-button(@click="goToCreate") Nuevo
    .credits-table
      ods-table(
        v-loading="loadingTable"
        style='width: 100%'
        :data='tableDataRendered'
        :default-sort = "{order: 'descending'}"
        )
        ods-table-column(prop='descomercio' label='Comercio' sortable)
        ods-table-column(prop='nomcompleto' label='Nombre y apellido' sortable)
          template(slot-scope="scope")
            div {{ nomcompleto(scope.row) }}
        ods-table-column(prop='usuario' label='Usuario' sortable)
          template(slot-scope="scope")
            div {{ nomb(scope.row) }}
        ods-table-column(prop='email' label='Email' sortable :maxlength="50")
        ods-table-column(prop='object' label='ACCIONES' class-name="cell-actions")
          template(slot-scope="scope")
            ods-actions-menu(
              customClass="card-menu"
              icon="overflow-menu"
              color="#888A91"
              size="18"
              popoverPosition="bottom-end")
              ul.menu
                li.menu__item
                  a(href="#" @click.prevent="goToDetail(scope.row.registro_Numero)")
                    ods-icon(name="eye" color="#B6B6B6" size="24" style="vertical-align: middle").ods-mr-2
                    | Ver detalle
                li.menu__item
                  a(href="#" @click.prevent="deleteQr(scope.row.registro_Numero)" style="color: #DE2F2F")
                    ods-icon(name="delete" color="#DE2F2F" size="24" style="vertical-align: middle").ods-mr-2
                    | Eliminar usuario

      div.footer
        paginator(
          :isNextPage="indMasDatos"
          :currentPage="currentPage"
          @buttonPrevAction="getPrevPage"
          @buttonNextAction="getNextPage")

    dialog-tex-edit(
        :dialogTextEdit="dialogTextEdit"
        :typeImg="aceptar"
        :title="titleNewUser"
        :subTitle="subTitle"
        :codeUser="codeUser"
        :codePass="codePass"
        @dialogClosed="closeDialogText($event)")
    DialogGenericWarning(
        :dialogError="dialogErrorImg"
        :message="warningMessage"
        :dialogWarning="dialogWarning"
        @dialogClosed="closeDialogWarning($event)")
    DialogConfirmSuccess(
      :dialogSuccess="dialogSuccess"
      @dialogClosed="closeDialogSuccess($event)")
</template>

<script>

import DialogTexEdit from '@/components/dialogs/DialogTexEdit'
import DialogGenericWarning from '@/components/dialogs/DialogGenericWarning'
import DialogConfirmSuccess from '@/components/dialogs/DialogConfirmSuccess'
import Paginator from '@/components/shared/Paginator'

import { Utils } from '@/utils/Utils.js'

export default {
  name: 'UsersTable',

  props: {
    comercio: {
      required: true
    }
  },

  data () {
    var validateNombre = (rule, value, callback) => {
      if (!value) {
        callback(new Error('Campo obligatorio'))
      } else {
        if (Utils.validateCaracEspecial(value)) {
          callback(new Error('Existen caracteres no permitidos'))
        } else {
          callback()
        }
      }
    }
    var validateApelli1 = (rule, value, callback) => {
      if (!value) {
        callback(new Error('Campo obligatorio'))
      } else {
        if (Utils.validateCaracEspecial(value)) {
          callback(new Error('Existen caracteres no permitidos'))
        } else {
          callback()
        }
      }
    }
    var validateApelli2 = (rule, value, callback) => {
      if (Utils.validateCaracEspecial(value)) {
        callback(new Error('Existen caracteres no permitidos'))
      } else {
        callback()
      }
    }
    var validateEmail = (rule, value, callback) => {
      if (!Utils.validateEmail(value)) {
        callback(new Error('Campo obligatorio'))
      } else {
        callback()
      }
    }
    return {
      defaultParams: { codcom: this.comercio.codcom },
      paginationParams: null,
      tableData: null,
      tableDataRendered: null,
      currentPage: null,
      indMasDatos: null,
      loadingTable: false,
      expandKey: [],
      // tableData: this.data,
      // itemsPerPage: 10,
      // currentPageData: 1,
      // totalData: 0,
      QRUsersFormData: {},
      showdrawer: false,
      UserTitleQR: 'Nuevo Empleado QR',
      editQR: false,
      createQR: false,
      rulesQR: {
        usuario: [
          { required: true, message: 'Campo obligatorio', trigger: 'blur' }
        ],
        nombre: [
          { required: true, validator: validateNombre, trigger: 'focus' }
        ],
        apelli1: [
          { required: true, validator: validateApelli1, trigger: 'blur' }
        ],
        apelli2: [
          { required: true, validator: validateApelli2, trigger: 'blur' }
        ],
        email: [
          { required: true, validator: validateEmail, trigger: 'blur' }
        ],
        tel_movil: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }]
      },
      sesionCodcom: {},
      dialogTextEdit: false,
      dialogErrorImg: false,
      dialogWarning: false,
      aceptar: 'aceptar',
      titleNewUser: 'Usuario Creado',
      subTitle: '',
      codePass: '',
      codeUser: '',
      warningMessage: '',
      submit: '',
      copytable: [],
      dialogSuccess: false

    }
  },

  watch: {
    // data (newData, oldData) {
    //   if (this.tableData) {
    //     this.tableData = newData
    //     this.totalData = newData.length
    //   }
    // }
  },

  methods: {
    async getData (params) {
      this.loadingTable = true
      // Listado de QR - Usuarios QR
      await this.$store.dispatch('listUsersQR', params)
        .then((res) => {
          this.loadingTable = false
          if (res.registros) {
            this.tableData = Array.isArray(res.registros) ? res.registros : [res.registros]
            this.tableDataRendered = this.tableData
          } else {
            this.tableData = null
            this.tableDataRendered = this.tableData
          }
          this.currentPage = res.pantPagina
          this.indMasDatos = res.indMasDatos
          this.paginationParams = {
            claveInicio: res.claveInicio,
            claveFin: res.claveFin
          }
          this.$emit('totalUsers', this.tableDataRendered ? this.tableDataRendered.length : 0)
        })
    },

    getInitialData () {
      const params = {
        ...this.defaultParams
      }
      this.getData(params)
    },

    getPrevPage () {
      const params = {
        ...this.defaultParams,
        ...this.paginationParams,
        retroceder: true
      }
      this.getData(params)
    },

    getNextPage () {
      const params = {
        ...this.defaultParams,
        ...this.paginationParams,
        avanzar: true
      }
      this.getData(params)
    },

    // Campos de filtrado, por si se usan, meter el input con el componente genérico de filtros
    // inputSearchFilter (text) {
    //   this.tableDataRendered = this.tableData.filter((res) => {
    //     return res.desperfil.toLowerCase().includes(text.toLowerCase()) ||
    //       res.nombre.toLowerCase().includes(text.toLowerCase()) ||
    //       res.apelli1.toLowerCase().includes(text.toLowerCase()) ||
    //       res.apelli2.toLowerCase().includes(text.toLowerCase()) ||
    //       res.usuario.toLowerCase().includes(text.toLowerCase())
    //   })
    // },

    closeDialogSuccess (e) {
      this.$emit('success', e)
      this.dialogSuccess = e
    },

    displayConfirmSuccess () {
      this.dialogSuccess = true
    },

    closeDialogText (e) {
      // this.$emit('success', e)
      this.dialogTextEdit = e
    },

    displayTextEdit (user, pass, msg) {
      this.dialogTextEdit = true
      this.codeUser = user
      this.codePass = pass
      this.subTitle = msg
    },

    addUserQr (fullDatos, QRUsers) {
      this.editQR ? this.submit = 'UpdateUserQr' : this.submit = 'insertUserQr'
      const submitPost = this.submit
      this.$refs[QRUsers].validate((valid) => {
        fullDatos.codcom = this.sesionCodcom.codcom
        // fullDatos.identcli = this.sesionCodcom.codcom
        if (valid) {
          fullDatos.usuario = fullDatos.usuario.toUpperCase()
          fullDatos.apelli1 = fullDatos.apelli1.toUpperCase()
          fullDatos.apelli2 = fullDatos.apelli2.toUpperCase()
          this.$store.dispatch(submitPost, fullDatos).then(r => {
            if (r.error === true) {
              // this.displayErrorDialog(r.data.runServiceResponse.return.descRetorno)
              this.dialogErrorImg = true
              this.displayErrorWarning(r.data.runServiceResponse.return.descRetorno)
            } else if (r.warning === true) {
              this.dialogErrorImg = true
              this.displayErrorWarning(r.data.runServiceResponse.return.descRetorno)
              // this.handleClose()
            } else {
              if (this.editQR) {
                this.getInitialData()
                this.displayConfirmSuccess()
                this.$message({
                  type: 'success',
                  message: 'Modificado usuario'
                })
                this.handleClose()
              } else {
                this.getInitialData()
                this.displayTextEdit(
                  fullDatos.usuario,
                  r.data.runServiceResponse.return.registros.tokenpasswd,
                    `Hemos creado el usuario ${fullDatos.usuario} asignado a ${fullDatos.nombre} ${fullDatos.apelli1}. Por favor indícale que su clave inicial es:`)
                this.handleClose()
              }
            }
          }).catch(e => {
            console.error('Error in list Users - App', e)
            this.handleClose()
          })
        }
      })
    },

    handleClose () {
      this.showdrawer = false
      this.editQR = false
      this.createQR = false
      this.QRUsersFormData = {}
      this.$refs.QRUsers.resetFields()
    },

    nomcompleto (row) {
      return `${row.nombre.toUpperCase()} ${row.apelli1.toUpperCase()} ${row.apelli2.toUpperCase()}`
    },

    nomb (row) {
      return `${row.usuario.toUpperCase()}`
    },

    goToCreate () {
      this.UserTitleQR = 'Nuevo Empleado QR'
      this.createQR = true
      this.showdrawer = true
    },

    goToDetail (index) {
      [...this.copytable] = this.tableData
      this.UserTitleQR = 'Editar Empleado QR'
      this.QRUsersFormData = this.copytable.filter((user) => user.registro_Numero === index)[0]
      this.QRUsersFormData.nombre = this.QRUsersFormData.nombre.toUpperCase()
      this.QRUsersFormData.apelli1 = this.QRUsersFormData.apelli1.toUpperCase()
      this.QRUsersFormData.apelli2 = this.QRUsersFormData.apelli2.toUpperCase()
      this.showdrawer = true
      this.editQR = true
    },

    deleteQr (userId) {
      // this.$emit('deleteQr', user)
      this.showDetailPage = false
      const user = this.tableData.filter((user) => user.registro_Numero === userId)[0]
      const h = this.$createElement
      this.$confirm(h('div', { class: { deletemessage: true } }, [
        h('p', { class: { text: true } }, 'Se va a eliminar el siguiente usuario:'),
        h('p', { class: { data: true } }, 'Usuario: ' + user.usuario),
        h('p', { class: { data: true } }, 'Nombre: ' + user.nombre),
        h('p', { class: { data: true } }, 'Apellidos: ' + user.apelli1),
        h('p', { class: { text: true } }, '¿Está seguro de que desea eliminar de forma permanente este usuario?')
      ]), 'Warning', {
        title: 'Confirmar eliminación permanente',
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('deleteUserQr', user.identcli)
          .then((res) => {
            if (res.warning === true) {
              this.$confirm(h('div', { class: { deletemessage: true } }, [
                h('p', { class: { text: true } }, 'Operación no disponible para el perfil del usuario')
              ]), 'Warning', {
                title: 'Tecnichal problems detected',
                cancelButtonText: 'Cancelar',
                type: 'warning'
              })
            } else {
              this.showDetailPage = false
              this.dialogMessage = 'Usuario eliminado con éxito'
              this.message = true
              this.getInitialData()
            }
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'eliminación de usuario cancelada'
        })
      })
    },

    dialogfin (msg) {
      this.$confirm(msg)
        .then(_ => {
          alert('biennnnnnnnnnnnn', msg)
        })
        .catch(_ => {
          alert('Malllllllllllll')
        })
    },

    displayErrorWarning (msg) {
      this.warningMessage = `${msg}`
      this.dialogWarning = true
    },

    closeDialogWarning (e) {
      this.dialogWarning = e
    }

    // handleSizeChange (val) {
    //   this.itemsPerPage = val
    //   this.handlePagination()
    // },

    // handleCurrentChange (val) {
    //   this.currentPageData = val
    //   this.handlePagination()
    // },

    // handlePagination (arr) {
    //   if (Array.isArray(this.data)) {
    //     this.tableData = this.data.slice(
    //       (this.currentPageData - 1) * this.itemsPerPage,
    //       this.currentPageData * this.itemsPerPage)
    //   }
    // }
  },

  components: {
    DialogTexEdit,
    DialogGenericWarning,
    DialogConfirmSuccess,
    Paginator
  },

  mounted () {
    this.getInitialData()
    // if (Array.isArray(this.data)) this.totalData = this.data.length
    // this.handlePagination()
    this.sesionCodcom = JSON.parse(sessionStorage.getItem('comercio'))
  }
}
</script>

<style lang="scss" scoped>
.notfound {
  margin-top: rem(28)
}

/deep/ .ods-table__row {
  cursor: pointer;
}

/deep/ .ods-table__expanded-cell {
  padding: rem(12) rem(24)!important;
  background: #F9F9FB;
}

/deep/ .ods-table__expanded-cell:hover {
  background-color: #F9F9FB!important;
}

/deep/ .ods-table__expanded-cell:hover td {
  border-bottom: 1px solid #d1d9de;
}

.tramos {
  .title {
    text-transform: uppercase;
  }

  .ods-table {
    background: #fff;
    margin: 12px 0;
  }

  /deep/ .ods-table thead th {
    padding: 0;
  }

  /deep/ .ods-table td, .ods-table th {
    padding: 4px 0;
  }

  /deep/ .ods-table__row--striped > td {
    background: #F0F0F0!important;
  }
}
.btnQr{
  display: flex;
  justify-content: flex-end;
}

.form-grid {
  margin-top: rem(24);
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto;
  column-gap: 48px;
}

.form-section:after {
    content: '';
    height: 1px;
    width: 100%;
    background: #A2ACB3;
    display: block;
    margin-top: 0.5rem;
}
</style>
